import { cableTouchesNode } from '@/utils/cableEndpoints'
import type { AnyNode } from '@/types/nodes'

type CableLike = {
  origen?: unknown
  origenId?: string
  destino?: unknown
  destinoId?: string
}

/**
 * Permite cambiar el tipo de un nodo solo si no tiene cables y la config
 * no contiene splitters, OLTs, puertos ocupados ni empalmes guardados.
 */
export function canChangeNodeType(node: AnyNode, cables: CableLike[]): boolean {
  for (const c of cables) {
    if (cableTouchesNode(c, node.id)) return false
  }

  const raw = (node as { config?: unknown }).config
  if (raw == null || typeof raw !== 'object' || Object.keys(raw as object).length === 0) {
    return true
  }

  const cfg = raw as Record<string, unknown>

  if (Array.isArray(cfg.splitters) && cfg.splitters.length > 0) return false
  if (Array.isArray(cfg.olts) && cfg.olts.length > 0) return false
  if (Array.isArray(cfg.empalmes) && cfg.empalmes.length > 0) return false

  if (Array.isArray(cfg.puertos)) {
    const puertos = cfg.puertos as Array<{ estado?: string }>
    if (puertos.some((p) => p.estado && p.estado !== 'libre')) return false
  }

  return true
}
